import { render, staticRenderFns } from "./Productions.vue?vue&type=template&id=1061cda6&scoped=true&"
import script from "./Productions.vue?vue&type=script&lang=js&"
export * from "./Productions.vue?vue&type=script&lang=js&"
import style0 from "./Productions.vue?vue&type=style&index=0&id=1061cda6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1061cda6",
  null
  
)

export default component.exports